module.exports = __webpack_public_path__ + "static/media/_akopan_Panorama1a.c6260c6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lostWorld/_akopan_Panorama1a.jpg
// module id = 37
// module chunks = 0